import PublicLayout from '../components/layouts/PublicLayout';
import { Container } from 'reactstrap';
import {useState, useEffect} from 'react';
import axios from 'axios';
import Head from 'next/head';
import { useRouter } from 'next/router'

function OurTeam({meta}) {
	const [loading, setLoading] = useState(false); 
	const router = useRouter();

	return (
		<>
			<Head>
				<meta name="keywords" content={meta ? meta.keywords : ''} />
				<title>{meta ? meta.title : ''}</title>
				<meta name="description" content={meta ? meta.description : ''} />
				<link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
			</Head>
			<div className="banner_breadcrumb_section" id="our_team">
				<div id="spinner" className="spinner_req_review" style={{"display": loading ? "block" : "none"}}>
					<div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
				</div>
				<Container fluid="xl">
					<h1 className="main-heading-lg">Our Team</h1>
				</Container>
			</div>
			<Container fluid="xl">
				  <div className="about_sec1-intro  top-spacing text-center" >
				  <p className="description-text">The right talent can expand your opportunities as a business in the same way that the right leads can drive growth for you as a vendor. Organizations need people who are skilled, enthusiastic, passionate and able to deliver on crucial goals. Providing you this is what we do at Toprow. Ours is a platform of people who love what they do!</p>
				  </div>
				  <div className="team-list-view padding-wrap">
					  <h2 className="main-heading text-center">Meet the team that drives our excellent results.</h2>
				  </div>
			</Container>
			<div className="home-quote-started_section">
				<Container fluid="xl">
					<div className="padding-wrap text-center">    
					<h4 className="main-heading">Ready to unleash your business potential?</h4>
					<p className="description-text-sm">Explore how Toprow can help you today.</p>
					</div>
				</Container>
			</div>	
		</>	
	)
}

// This gets called on every request
export async function getServerSideProps({ req, res}) {
    try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/our-team', { headers: {
            "Accept": "application/json" }
        });

        return { props: { meta: response.data.data,  } }

    } catch (err) {
        const meta = false;

        return { props: { meta } };
    }
}


OurTeam.Layout = PublicLayout;

export default OurTeam
